export default __webpack_public_path__ + "static/media/Clock.08e0e015.svg";